import React from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';

// Farm name for farm-scoped resources, "All Farms" for global ones
const TenantAssetFarmScope = ({ farm }) => (
  farm ? <>{farm.name}</> : <FormattedMessage id="general.allFarms" />
);

TenantAssetFarmScope.propTypes = {
  farm: T.shape({
    id: T.number,
    name: T.string,
  }),
};

export default TenantAssetFarmScope;
